// extracted by mini-css-extract-plugin
module.exports = {"button":"Pagimation_button__3V8D-","icon":"Pagimation_icon__2Do-9","div":"Pagimation_div__n5hlH","text":"Pagimation_text__2x4AZ","page":"Pagimation_page__1FdB6"};